module.exports = __webpack_public_path__ + "img/avatar-s-25.eb6156c0.jpg";